<div *ngIf="dialogData" class="flex flex-col">
  <div class="flex flex-col">
    <h3>Extend grace period for {{ dialogData.code }}</h3>
  </div>

  <div class="flex flex-col">
    <sbnb-date-picker
      [numMonths]="1"
      [rangeSelect]="false"
      [checkInOutStyling]="false"
      [showDurationLabels]="false"
      (click)="$event.stopPropagation()"
      (datesSelected)="onDatesSelected($event)"></sbnb-date-picker>
  </div>

  <div class="flex flex-row mt-8 justify-end gap-4">
    <button type="submit" mat-flat-button class="button__secondary" (click)="onCancel()">Cancel</button>
    <sbnb-button mat-flat-button (click)="onSave()" [loading]="isLoading">Save</sbnb-button>
  </div>
</div>
